module.exports = __webpack_public_path__ + "static/media/sombra-lateral-livro-todo.cc3526ec.svg";